<template>
  <!-- 申请次数 -->
  <div class="cardPool">
    <div class="search">
    <van-search
      v-model="dataForm.idNo"
      show-action
      placeholder="请输入搜索身份证号"
      @search="onSearch"
      @input="onSearch"
    >
      <template #action>
        <div @click="onSearch(dataForm.idNo)">搜索</div>
      </template>
    </van-search>
    <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin-right: 5%;">{{ queryDataLength }}</span>
    </div>
    <div class="searchContent">
      <van-list
        :finished="finished"
        finished-text="没有更多了"
      >
      <van-cell v-for="item in responseDataArray" :key="item.id" :title="'身份证号：'+item.idNo" >
        <van-button  plain hairline type="info" @click="showDetail(item)">查看</van-button>
      </van-cell>
      </van-list>
    </div>

    <!-- 450881200010058922 -->
    <!-- 详情 -->
        <van-overlay :show="showDataDetail" @click="showDataDetail=false">
          <div class="wrapper" @click.stop>
            <div class="cardPoolBlock">
              <div class="title">
                <span>详情信息
                  <van-icon name="close" class="cancel" @click="showDataDetail = false"/>
                </span>
              </div>
              <van-cell :title="'身份证号：'">{{ showList.idNo }}</van-cell>
              <van-cell :title="'创建时间：' ">{{ showList.createTime | formatTime }}</van-cell>
              <van-cell :title="'申请次数：' ">{{ showList.applyCount }}</van-cell>
              <div style="margin: 16px;">
                <van-button round block type="info" @click="reset(showList)">
                  重置申请次数</van-button>
              </div>
            </div>
          </div>
        </van-overlay>

      <!-- 重置申请次数 -->
       <!-- <van-overlay :show="resetShow" @click="resetShow=false">
        <div class="wrapper" @click.stop>
            <div class="cardPoolBlock">
              <div class="title">
                <span>重置申请次数</span>
              </div>
              <van-row style="margin: 8% 0;">
                <van-field label="身份证号:" v-model="resetForm.idNo" disabled></van-field>
                <van-field label="用户名：" v-model="resetForm.userName" placeholder="请输入用户名"></van-field>
                 <div></div>
              </van-row>
              <van-row style="margin-top: 8%;">
                <van-col :span="12">
                  <van-button @click="cancel" plain hairline type="info" class="buttons">取消</van-button>
                </van-col>
                <van-col :span="12">
                  <van-button @click="confirm" plain hairline type="info" class="buttons">确认</van-button>
                </van-col>
              </van-row>
            </div>
          </div>
       </van-overlay> -->
  </div>
</template>

<script>
import {QueryIdCardPool,ResetIdCardApply} from '@/my_js//HttpRequest.js'
import {formatTime} from '@/utils/date.js'
import { Notify,Dialog } from 'vant'
import store from '../../store'
export default {
  // mounted(){
  //   this.echartsInit()
  // },
  components:{

  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    }
  },
  data(){
    return{
      dataForm:{
        idNo:'',//身份证号码
      },
      // list:[],
      loading:false,
      finished:false,
      responseDataArray:[],//响应数据
      showDataDetail:false,//详情显示
      showList:[],//详情信息列表
      resetShow:false,//重置
      // userName:'',//用户名
      resetForm:{
        idNo:'',//身份证号
        userName:'',//用户名
      },
      queryDataLength:null,//查询到的数据量
    }
  },
  methods:{
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },
    // 搜索
    onSearch(val){
      // this.loading = true
      // console.log(val);
      // console.log(typeof(val));
      // console.log(this.dataForm);
      // QueryIdCardPool(this.dataForm).then(res =>{
      //   console.log(res);
      //   this.responseDataArray = res.data
      //   console.log( 'this.responseDataArray',this.responseDataArray);
      //   this.finished = true
      //   this.loading=false
      // })
      // "dateBegin": "2024-06-27T01:54:26.024Z",
      // "dateEnd": "2024-06-27T01:54:26.024Z"
      // const data = {
      //   idNo:'',
      // }
      if(val){
        const data = {
          idNo:val,
          applyCount: 0,
        }
        console.log('data',data);
        
        QueryIdCardPool(data).then(res =>{
          console.log('查询数据',res);
          this.responseDataArray = res.data
          if(this.responseDataArray.length == 0){
            Notify({message:'查询不到该数据',type:'warning'})
            this.queryDataLength = null
          }else{
            this.queryDataLength = this.responseDataArray.length
            console.log( 'this.responseDataArray',this.responseDataArray);
            this.finished = true
            this.loading=false
          }
        })
      }
    },
    // 查看详情
    showDetail(val){
      console.log('val',val);
      this.showDataDetail = true
      this.showList = val
    },
    // 重置申请次数
    reset(val){
      console.log(val);
      // this.resetShow = true
      // store.state.userName
      // this.showDataDetail = false
      // this.resetForm.idNo = this.showList.idNo
      Dialog.confirm({
        title: '提示',
        message: '是否重置该用户申请次数？',
        })
        .then(() => {
          // on confirm
          console.log('点击了确定');
          this.showDataDetail = false
          this.resetForm.idNo = this.showList.idNo
          this.resetForm.userName = store.state.userName
          console.log('resetForm:',this.resetForm);
          ResetIdCardApply(this.resetForm).then(res =>{
            console.log('重置次数响应数据：',res);
            Notify({type:'success',message:res.msg})
            // 清空表单数据
            this.resetForm = {
              idNo:'',
              userName:''
            }
            this.dataForm.idNo = ''
            this.responseDataArray = []
          })
        })
        .catch(() => {
          // on cancel
          console.log('点击了取消');
          this.showDataDetail = false
          // 清空表单数据
          this.resetForm = {
            idNo:'',
            userName:''
          }
      });
    },
    // 提交重置申请
    // confirm(){
    //   console.log('this.resetForm',this.resetForm);
    //   this.resetShow = false
    //   ResetIdCardApply(this.resetForm).then(res =>{
    //     console.log('重置次数响应数据：',res);
    //     Notify({type:'success',message:res.msg})
    //   })
    // },
    // 取消
    // cancel(){
    //   // 清空表单数据
    //   this.resetForm = {
    //     idNo:'',
    //     userName:''
    //   }
    //   this.resetShow = false
    // },

   
  }

}
</script>

<style lang="scss" >
.cardPool{
  width: 100%;
  height: 100%;
  .queryHeader{
    width: 100%;
    height: 8%;
  }
  .searchContent{
    .van-cell__title{
      line-height: 50px;
    }
  }

  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }

  .wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .title{
    margin-top: 3%;
    .cancel{
      float: right;
      margin-right: 3%;
      font-size: 28px;
    }
  }
  .cardPoolBlock{
    width: 95%;
    height: 45%;
    border-radius: 8px;
    background-color: #fff;
    .van-cell__value{
      text-align: left;
    }
  }

}
.van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
</style>